"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Клик на добавление рекомендуемого навыка при заполнении вакансии работодателем */
const vacancyKeySkillRecommendedAddButtonClick = ({ vacancyCreateDraftId, vacancyId, keySkill, position, keySkillNumber, competenceName, competenceId, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("vacancy_key_skill_recommended_add", { vacancyCreateDraftId, vacancyId, keySkill, position, keySkillNumber, competenceName, competenceId, ...analyticsParams });
exports.default = vacancyKeySkillRecommendedAddButtonClick;
